import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.authService.isLoggedIn) {
      this.router.navigate(['account', 'login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (!this.authService.isAdmin()) {
      this.router.navigate(['/shipments']);
      return false;
    }

    return true;
  }
}
